<template>
  <div id="app">
    <FlashMessage :position="'right top'" />
    <building-units-status
      :floors="floors"
    />
    <table-floor
      :floors="floors"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BuildingUnitsStatus from './component_floors/buildingUnitsStatus.vue';
import TableFloor from './component_floors/tableFloors.vue';

export default {
  components: {
    TableFloor,
    BuildingUnitsStatus,
  },
  computed: {
    ...mapState({
      floors: (state) => state.floor.floors
    })
  },
  created: function() {
    this.$store.dispatch('floor/getFloors');
  }
};
</script>
